import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {RoomModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function editRoomService(dto: RoomModel) {
  return await axios.put<ResponseObject<RoomModel>>(`${BASEURL}/room/updateRoom`, dto)
}
